import { render, staticRenderFns } from "./Img.vue?vue&type=template&id=4971f16d&scoped=true"
import script from "./Img.vue?vue&type=script&lang=js"
export * from "./Img.vue?vue&type=script&lang=js"
import style0 from "./Img.vue?vue&type=style&index=0&id=4971f16d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4971f16d",
  null
  
)

export default component.exports